import { render, staticRenderFns } from "./MobileBtn.vue?vue&type=template&id=567e8fb2&scoped=true"
import script from "./MobileBtn.vue?vue&type=script&lang=js"
export * from "./MobileBtn.vue?vue&type=script&lang=js"
import style0 from "./MobileBtn.vue?vue&type=style&index=0&id=567e8fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e8fb2",
  null
  
)

export default component.exports